function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M74.3,63.9c-10.6-13-24.4-18.3-31.7-20.7c2.4,7.3,8.1,21.1,20.7,31.7c8.3,6.7,15.6,10.4,25,14 C84.9,79.7,81.1,72.2,74.3,63.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M48.1,67.3c-2.4-4.5-4.7-9.1-6.7-14.4c-0.6,4.7-1.4,8.7-2.4,12.2c-0.2,5.5,0,10.6,1,14.8 c0.4,2.4,0.8,4.9,1.2,6.9c1,6.3,1.8,10.4,3.5,14.4c0.2-1,0.6-1.8,0.6-2.6c1.8-6.3,3.7-13,3.7-22.3C48.7,73.6,48.5,70.6,48.1,67.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M37.4,45.2c-4.9,6.9-11.8,17.9-14,25.4c-1.8,6.3-2.6,11.6-2.6,16c3.3-4.1,6.5-9.3,9.5-15.6 C34.1,63.5,36.4,52.3,37.4,45.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M66.8,48.6c-4.5-2.4-9.1-4.7-14.4-6.7c4.7-0.6,8.7-1.4,12.2-2.4c5.5-0.2,10.6,0,14.8,1 c2.4,0.4,4.9,0.8,6.9,1.2c6.3,1,10.4,1.8,14.4,3.5c-1,0.2-1.8,0.6-2.6,0.6c-6.3,1.8-13,3.7-22.3,3.7C73.1,49.2,70.1,49,66.8,48.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M44.7,37.9c6.9-4.9,17.9-11.8,25.4-14c6.3-1.8,11.6-2.6,16-2.6c-4.1,3.3-9.3,6.5-15.6,9.5 C63,34.6,51.8,36.8,44.7,37.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M21.7,41.7c-4.5,1.2-7.5,3-10,4.7c-0.2,0.2-0.8,0.4-1.2,0.8c2.2,0.2,4.5,0,7.7-0.4c1-0.2,2.2-0.2,3.7-0.4 c1.8-0.2,4.1-0.8,6.3-1.4c1.6-1.2,3.9-2.2,6.3-3.5c-2.6-0.2-5.1-0.6-7.5-1C25,40.9,23.4,41.3,21.7,41.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M41.2,22.2c1.2-4.5,3-7.5,4.7-10c0.2-0.2,0.4-0.8,0.8-1.2c0.2,2.2,0,4.5-0.4,7.7c-0.2,1-0.2,2.2-0.4,3.7 c-0.2,1.8-0.8,4.1-1.4,6.3c-1.2,1.6-2.2,3.9-3.5,6.3c-0.2-2.6-0.6-5.1-1-7.5C40.4,25.5,40.8,23.8,41.2,22.2z"
}), React.createElement("rect", {
  x: 31.1,
  y: 25,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -13.741 32.3976)",
  className: "st0",
  width: 2.3,
  height: 15.5
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144.7 132.8",
    style: {
      "enableBackground": "new 0 0 144.7 132.8"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ornament.8a830c12.svg";
export { SvgComponent as ReactComponent };